import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';

export default function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: services, loading } = usePublicList('services');
  const sorted = [...services].sort((a, b) => a.order - b.order);
  const service = services.find((s) => String(s.id) === String(id)) || sorted[0];

  if (loading) return <section className="section"><div className="container"><p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p></div></section>;
  if (!service) return <section className="section"><div className="container"><p style={{ textAlign: 'center' }}>Tapılmadı</p></div></section>;

  const paragraphs = (service.content || '').split('\n\n').map((text, i) => ({ id: `${service.id}-p-${i}`, text }));
  const contentIsHtml = typeof service.content === 'string' && /<[a-z][\s\S]*>/i.test(service.content);

  return (
    <section className="section">
      <div className="container">
        <div className="svc-detail">
          <div className="svc-body">
            <div style={{ textAlign: 'center' }}>
              <h3>{service.title}</h3>
            </div>
            {contentIsHtml ? (
              <div className="rich-content" dangerouslySetInnerHTML={{ __html: service.content }} />
            ) : (
              paragraphs.map((p) => <p key={p.id}>{p.text}</p>)
            )}
          </div>
          <aside className="svc-side">
            {sorted.map((s) => (
              <div key={s.id}
                className={'svc-side-item ' + (String(s.id) === String(service.id) ? 'active' : '')}
                onClick={() => navigate(`/xidmetler/${s.id}`)}>
                {s.title}
              </div>
            ))}
          </aside>
        </div>
      </div>
    </section>
  );
}
